module.exports = require("github:jspm/nodelibs-url@0.1.0/index");